export function X() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M17.7682 17.3595C18.1216 17.7839 18.0646 18.4141 17.6403 18.7676C17.4533 18.9233 17.2262 18.9995 17.0006 18.9995C16.714 18.9995 16.4297 18.8769 16.2322 18.6395L11.9997 13.5346L7.76859 18.6126C7.57084 18.8499 7.28673 18.9726 7.00018 18.9726C6.77459 18.9726 6.5477 18.8964 6.36052 18.7406C5.93616 18.3872 5.87897 17.7569 6.23258 17.3326L10.698 11.9734L6.23183 6.64116C5.87832 6.2168 5.93544 5.58651 6.35989 5.23308C6.78362 4.87872 7.41391 4.93572 7.76796 5.36102L11.9997 10.4379L16.2308 5.35995C16.5839 4.9356 17.2145 4.8781 17.6388 5.23202C18.0632 5.58545 18.1204 6.21573 17.7668 6.64009L13.3013 11.9993L17.7682 17.3595Z" />
    </svg>
  );
}
